export var Feature = 'Feature';
export var FeatureCollection = 'FeatureCollection';
export var MultiPoint = 'MultiPoint';



//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-geo/src/constants.js
// module id = 366
// module chunks = 0